<template>
  <v-card flat>
    <v-card-title class="title-font">
      PHOTOGRAMMETRY SYSTEM <v-spacer />
      <div
        v-if="showErrors && !photogrammetrySystem"
        class="error--text text-body-2"
      >
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please make a selection </span>
      </div>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      Please specify what photogrammetry system was used from the list given.
    </v-card-subtitle>
    <v-card-text class="pa-4">
      <v-select
        v-model="photogrammetrySystem"
        :items="photogrammetrySystems"
        dense
        outlined
        hide-details
        :menu-props="{ rounded: '10' }"
        placeholder="Photogrammetry System"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PhotogrammetrySystem",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      showErrors: false,
      photogrammetrySystems: [
        {
          text: "iMetric ICam",
          value: "icam"
        },
        {
          text: "MicronMapper",
          value: "micron_mapper"
        },
        {
          text: "PIC Dental Photogrammetry",
          value: "pic"
        },
        {
          text: "Tupel 3D (Grammee)",
          value: "tupel"
        },
        {
          text: "Shining 3D Aoral Scan Elite (Intraoral Photogrammetry) - Coded Scan Bodies",
          value: "shining"
        }
      ]
    }
  },

  computed: {
    photogrammetrySystem: {
      get() {
        return this.value
      },
      set(val) {
        this.showErrors = false
        this.$emit("input", val)
      }
    }
  },

  methods: {
    validate() {
      if (!this.photogrammetrySystem) this.showErrors = true
      this.valid = !!this.photogrammetrySystem
      return !!this.photogrammetrySystem
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
